import { SvgIcon } from '../../../components'
import * as React from 'react'
import { useTheme } from '../../../hooks/useTheme'

function OpenInNew(props) {
  const theme = useTheme()

  return (
    <SvgIcon
      className='open-in-new-icon'
      viewBox='0 -960 960 960'
      sx={{
        fontSize: '1rem',
        height: '1rem',
        width: '1rem',
        fill:
          props?.variant === 'contained' ? '#FFF' : theme.palette.primary.main
      }}
    >
      <path d='M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z' />
    </SvgIcon>
  )
}

const MemoOpenInNew = React.memo(OpenInNew)

export default MemoOpenInNew
